export const goose_details = [
    {id: 1, text: "Status", value: "Owned"},
    {id: 2, text: "DOB", value:"2022-07-10"},
    {id: 3, text: "AKC", value:"SS35790903"},
    {id: 4, text: "Advanced Cardiac", value:"NORMAL AUSC+ECHO LR-ACA4361/12M-VPI"},
    {id: 5, text: "OFA Hips", value:" EXELLENT"},
    {id: 6, text: "Elbows", value:"NORMAL"},
    {id: 7, text: "Eyes", value:"Cleared NORMAL"},
    {id: 8, text: "Genotype", value:"B/B"},
    {id: 9, text:"Pawprints Genetic Panel", value:"Clear on all diseases."}
];